import React, { FC, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import { IInput } from "types/interfaces";
import { updateUserPassword } from "actions/userActions";
import { RootState } from "store";
import { Alert } from "shared/Alert/Alert";
import { useHistory } from "react-router";

export interface PageUpdatePasswordProps {
  className?: string;
}

const PageUpdatePassword: FC<PageUpdatePasswordProps> = ({
  className = "",
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const state = useSelector(
    (state: RootState) => state.userForgetPasswordUpdate
  );

  const [password, setPassword] = useState<IInput>({ value: "", warning: "" });
  const [password2, setPassword2] = useState<IInput>({
    value: "",
    warning: "",
  });

  const [token, setToken] = useState<string>("");

  useEffect(() => {
    if (state.status?.success) {
      history.push("/login");
    }
  }, [state]);

  useEffect(() => {
    const getToken = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get("token");
    };

    if (!getToken()) {
      window.location.href = "/";
    } else {
      setToken(getToken()!);
    }
  }, []);

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!password.value) {
      return setPassword({
        value: password.value,
        warning: "Masukkan password",
      });
    }

    if (password.value !== password2.value) {
      return setPassword2({
        value: password2.value,
        warning: "Masukkan password yang sama",
      });
    }
    if (
      password.value &&
      password2.value &&
      !password.warning &&
      !password2.warning
    )
      dispatch(updateUserPassword(password.value, token));
  };

  return (
    <div
      className={`nc-PageUpdatePassword  ${className}`}
      data-nc-id="PageUpdatePassword"
    >
      <Helmet>
        <title>Lupa Password</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        {state.error && <Alert>{state.error}</Alert>}

        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Ubah Password
        </h2>
        <div className="max-w-md mx-auto space-y-6 ">
          <form className="grid grid-cols-2 gap-6" onSubmit={handleSubmit}>
            <label className="block col-span-2">
              <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                Password
              </span>
              <Input
                type="password"
                className="mt-1"
                placeholder="password"
                value={password.value}
                warning={password.warning}
                onChange={(e) => {
                  if (e.target.value.length < 8) {
                    setPassword({
                      value: e.target.value,
                      warning: "Password minimal 8 karakter",
                    });
                  } else setPassword({ value: e.target.value, warning: "" });

                  if (e.target.value !== password2.value) {
                    setPassword2({
                      value: password2.value,
                      warning: "Masukkan password yang sama",
                    });
                  }
                }}
              />
            </label>
            <label className="block col-span-2">
              <span className="flex text-neutral-800 dark:text-neutral-200">
                Ulangi Password
              </span>
              <Input
                type="password"
                className="mt-1"
                placeholder="ulangi password"
                value={password2.value}
                warning={password2.warning}
                onChange={(e) => {
                  if (e.target.value !== password.value) {
                    setPassword2({
                      value: e.target.value,
                      warning: "Masukkan password yang sama",
                    });
                  } else setPassword2({ value: e.target.value, warning: "" });
                }}
              />
            </label>
            <ButtonPrimary
              type="submit"
              className={`col-span-2 bg-primary-6000 dark:bg-primary-6000 hover:bg-primary-700`}
              loading={state.loading}
            >
              {/* {loading ? "Loading..." : "Perbaharui Password"} */}
              Perbaharui Password
            </ButtonPrimary>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PageUpdatePassword;
